import React, { useContext, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { CartContext } from "./CartContext";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const Recapitulatif = () => {
  const { cartItems } = useContext(CartContext);
  const infos = JSON.parse(localStorage.getItem("checkoutInfo") || "{}");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const total = useMemo(() => {
    return cartItems.reduce((sum, item) => {
      const unit =
        item.promo_active && item.promo_price ? Number(item.promo_price) : Number(item.price);
      return sum + unit * Number(item.quantity || 1);
    }, 0);
  }, [cartItems]);

  const handlePaiement = async () => {
    setErr("");
    setLoading(true);
    try {
      const res = await fetch("/api/checkout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cartItems, checkoutInfo: infos }),
      });
      const data = await res.json();
      if (data?.url) window.location.href = data.url;
      else setErr("Erreur de paiement. Réessaie.");
    } catch {
      setErr("Erreur lors de la tentative de paiement.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <Helmet>
        <title>Récapitulatif – Deenzine</title>
        <meta name="description" content="Vérifie ta commande puis paye en toute sécurité via Stripe." />
        <link rel="canonical" href={window.location.origin + "/recapitulatif"} />
      </Helmet>

      <Navbar />

      <section className="section">
        <div className="container">
          <div className="grid">
            <div style={{ gridColumn: "span 7" }}>
              <div className="card cardPad">
                <h1 className="h2" style={{ color: "var(--brand)" }}>Récapitulatif</h1>
                <p className="p">Vérifie tes infos avant paiement.</p>

                <div className="hr" />

                <div style={{ fontWeight: 900, marginBottom: 8 }}>Informations client</div>
                <div className="p">
                  <strong>Nom :</strong> {infos.nom || "-"} <br />
                  <strong>Adresse :</strong> {infos.adresse || "-"}, {infos.ville || "-"}, {infos.codePostal || "-"} <br />
                  <strong>Email :</strong> {infos.email || "-"}
                </div>

                <div className="hr" />

                <div style={{ fontWeight: 900, marginBottom: 8 }}>Produits</div>
                {cartItems.map((item, i) => {
                  const unit =
                    item.promo_active && item.promo_price ? Number(item.promo_price) : Number(item.price);
                  return (
                    <div key={i} className="card cardPad" style={{ boxShadow: "none", marginBottom: 10 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                        <div>
                          <div style={{ fontWeight: 900 }}>{item.name}</div>
                          <div className="p">
                            {item.selectedColor ? `Couleur : ${item.selectedColor} • ` : ""}
                            Qté : {item.quantity}
                          </div>
                        </div>
                        <div className="badge">{(unit * Number(item.quantity || 1)).toFixed(2)} €</div>
                      </div>
                    </div>
                  );
                })}

                <div style={{ marginTop: 10 }}>
                  <Link to="/checkout-form" className="btn btnSecondary" style={{ width: "100%" }}>
                    Modifier mes infos
                  </Link>
                </div>
              </div>
            </div>

            <aside style={{ gridColumn: "span 5" }}>
              <div className="card cardPad" style={{ position: "sticky", top: 96 }}>
                <div className="badge">Étape 2/2 • Paiement</div>
                <h2 className="h2" style={{ fontSize: 20, marginTop: 10 }}>Total</h2>
                <div className="hr" />
                <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 900, fontSize: 18 }}>
                  <span>À payer</span>
                  <span>{total.toFixed(2)} €</span>
                </div>
                <p className="p" style={{ marginTop: 10 }}>
                  Paiement sécurisé via Stripe. Aucune donnée bancaire stockée.
                </p>

                {err && (
                  <div className="badge" style={{ marginTop: 12, borderColor: "rgba(179,62,62,.25)" }}>
                    ❌ {err}
                  </div>
                )}

                <button className="btn" onClick={handlePaiement} disabled={loading || cartItems.length === 0} style={{ width: "100%", marginTop: 14 }}>
                  {loading ? "Redirection…" : "Payer →"}
                </button>

                {cartItems.length === 0 && (
                  <div className="badge" style={{ marginTop: 12 }}>
                    Ton panier est vide.
                  </div>
                )}
              </div>
            </aside>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Recapitulatif;
